export default {
  isAuthenticated: state => !!state.token,
  accessToken: state => state.token.access_token,
  tokenType: state => state.token.token_type,
  expiresIn: state => state.token.expires_in,
  authStatus: state => state.status
};
